// extracted by mini-css-extract-plugin
export default {"vendorIdField":"VendorIdField_vendorIdField__OON-i"};